import { Link } from 'react-router';
import { Image } from '../../../common/components/Image';
import { SITE_LOGO_SRC } from '../../../common/staticAssets.constants';

function Logo() {
  return (
    <Link to="/" className="header__logo">
      <Image src={SITE_LOGO_SRC} alt="Logo" width={150} height={70} priority />
    </Link>
  );
}

export default Logo;
